import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './InputWrapper.module.scss';
interface Props {
	children: React.ReactChild | React.ReactChild[];
	className?: string;
}

const InputWrapper: React.FC<Props> = ({ children, className }) => {
	return (
		<div className={joinClasses([styles.wrapper, className])}>{children}</div>
	);
};

export default InputWrapper;
